<template>
  <b-collapse class="panel" :open="true">
    <template #trigger>
      <p class="panel-heading">
	{{ label }}
      </p>
    </template>
    <slot></slot>
  </b-collapse>
</template>

<script>
 export default {
   props: {
     label: {
       type: String,
       required: true
     }
   }
 }
</script>
